declare var require;

//import { THREE } from 'enable3d'

// require('../vendors/lib/ammo');
//@ts-ignore
window.THREE = require('../vendors/lib/three.min.js');
//@ts-ignore
require('../vendors/lib/OrbitControls');

Ammo();
//@ts-ignore
// window.THREE = require('../node_modules/three/build/three.js');
// require('../vendors/OrbitControls');
